/* eslint-disable no-loops/no-loops */
import { ViewportScroller } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router, Scroll } from "@angular/router";
import { ClaimDetailsStateService } from "@modules/core/state";
import { ReportsService } from "@modules/report/services/report-service/report.service";
import { delay, filter } from "rxjs";
import { Report } from "../../models/report.interface";

@Component({
  selector: "icr-report",
  templateUrl: "./report.component.html",
  styleUrls: ["report.component.scss"],
  standalone: false,
})
export class ReportComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() data: Report[] = [];
  public pageTitle = "Initial Claim Report";
  dataItems: Report[];
  activeHeader: string = "";
  subheaders: HTMLElement[];

  ngOnInit() {
    const claimNumberString: string =
      this.activatedRoute.snapshot.params.claimNumber;
    this.getInitialClaimReport(claimNumberString);
    this.claimDetailsStateService.onSetPageScrollingEnabled(false);
  }

  ngAfterViewInit() {
    this.getSubheaders();
  }

  ngOnDestroy(): void {
    this.claimDetailsStateService.onSetPageScrollingEnabled(true);
  }

  constructor(
    private reportsService: ReportsService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private viewportScroller: ViewportScroller,
    private router: Router,
    private claimDetailsStateService: ClaimDetailsStateService
  ) {
    this.setupScrollHandling();
  }

  getInitialClaimReport(claimNumber: string) {
    this.reportsService.getReport(claimNumber).subscribe((res) => {
      this.dataItems = this.mapTNCReportToInitialClaimReport(res.reports);
      this.cdr.detectChanges();
    });
  }

  mapTNCReportToInitialClaimReport(inputArray: any): Report[] {
    return inputArray.map((item: any) => ({
      anchorId: item.anchorId,
      anchorlabel: item.anchorLabel,
      content: item.content,
    }));
  }

  dataScroll(e: Event) {
    this.getSubheaders();
    this.calculateActiveHeader(e.target as Element, this.getSubheaders());
    this.reportsService.setActiveHeader(this.activeHeader.toString());
  }

  private setupScrollHandling() {
    /**
     * When routes are changed and if the router fires a scroll event, handle position or anchor events.
     * Needs to have a minor delay before firing so it allows views to fully render before invoking scrollTo.
     */
    this.viewportScroller.setOffset([0, 130]);

    this.router.events
      .pipe(
        filter((e) => e instanceof Scroll),
        delay(200)
      )
      .subscribe((e: Scroll) => {
        if (e.position) {
          this.viewportScroller.scrollToPosition(e.position);
        } else if (e.anchor) {
          const container = document.getElementById("report-container");
          const targetElement = document.getElementById(e.anchor);
          // eslint-disable-next-line functional/immutable-data
          container!.scrollTop = targetElement!.offsetTop;
        }
      });
  }

  getSubheaders(): HTMLElement[] {
    const headers = document.getElementsByClassName(
      "subheader"
    ) as HTMLCollectionOf<HTMLElement>;
    const headersArray = Array.from(headers);

    return headersArray;
  }

  calculateActiveHeader(area: Element, headers: HTMLElement[]) {
    const maxStylingOffset = 32; // the 32 and 16 are to account for styling
    const minStylingOffset = 16;
    const lastHeader: HTMLElement = headers[headers.length - 1];
    for (let i = 0; i < headers.length; i++) {
      if (area.scrollTop >= lastHeader.offsetTop - minStylingOffset) {
        this.activeHeader = lastHeader.id;
        break;
      } else if (
        area.scrollTop >= headers[i].offsetTop - minStylingOffset &&
        i + 1 < headers.length &&
        area.scrollTop < headers[i + 1].offsetTop - maxStylingOffset
      ) {
        this.activeHeader = headers[i].id;
        break;
      }
    }
  }
}
